import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  Button,
  VStack,
  Text,
  Box,
  Stack,
  useColorModeValue,
} from '@chakra-ui/react';
import { TemplateType } from '../../../../store/types/template';

interface TemplateTypeChangeWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  currentType: TemplateType;
  newType: TemplateType;
}

const templateTypeLabels: Record<TemplateType, string> = {
  generic: 'Generic pass',
  loyalty: 'Loyalty pass',
  eventTicket: 'Event ticket',
  transit: 'Transit',
  stampCard: 'Stamp card',
};

const TemplateTypeChangeWarningModal = ({
  isOpen,
  onClose,
  onConfirm,
  currentType,
  newType,
}: TemplateTypeChangeWarningModalProps) => {
  const modeText = useColorModeValue('secondaryDark08', '#DDDDDD');

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Modal onClose={onClose} isOpen={isOpen} size="xl">
      <ModalOverlay />
      <ModalContent p={8}>
        <ModalCloseButton />
        <VStack spacing="30px">
          <Text textStyle="heading4">Switch Template Type?</Text>
          <Box>
            <Text textStyle="bodyFamilyRegular" color={modeText}>
              You are about to switch from{' '}
              <strong>{templateTypeLabels[currentType]}</strong> to{' '}
              <strong>{templateTypeLabels[newType]}</strong>.
            </Text>
          </Box>
          <Box>
            <Text
              textAlign="center"
              textStyle="bodyFamilyRegular"
              color={modeText}
            >
              Some fields may be cleared on switching due to different template
              type requirements. This action cannot be undone.
            </Text>
          </Box>
        </VStack>
        <Stack
          mt={8}
          spacing="10px"
          direction={{ base: 'column', sm: 'row' }}
          width={{ base: 'full', sm: 'auto' }}
          justifyContent="center"
        >
          <Button
            onClick={onClose}
            variant="secondary"
            width={{ base: 'full', sm: 'auto' }}
          >
            <Text>Cancel</Text>
          </Button>
          <Button width={{ base: 'full', sm: 'auto' }} onClick={handleConfirm}>
            Switch Type
          </Button>
        </Stack>
      </ModalContent>
    </Modal>
  );
};

export default TemplateTypeChangeWarningModal;
